/* =============================================================================
   Fines Foam — product page behavior.

   Everything here is a progressive enhancement. With JavaScript switched off
   the page still renders a complete product: the gallery is a native
   scroll-snap track, the accordions are <details>, and the buy form carries a
   real <select name="id"> so any variant can still be bought.

   What this file adds:
     - variant resolution from the option radios
     - ?variant= in the URL kept in sync (replaceState, no history spam)
     - live price / compare-at / savings / Afterpay / stock / button state
     - gallery filtered and jumped to the media for the selected color
     - add to cart over fetch, with the free gift and the selected add-on,
       announcing FF.emit('cart:added') for the cart drawer. Any failure falls
       back to a plain form POST.
     - the full-screen lightbox, which pages the SAME filtered media list the
       gallery is showing
     - the size guide drawer
     - the sticky buy bar, shown by an IntersectionObserver on the buy box and
       suppressed by a second one on the footer

   The three dialogs/overlays reuse FF.trapFocus and FF.lockScroll rather than
   each growing their own.

   Contract with ff-main-product.liquid: every hook is a data- attribute, so
   the markup can be restyled without touching this file.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-ff-pdp]');
  if (!root) return;

  var FF = window.FF || {};

  /* ---------------------------------------------------------------------- */
  /* Helpers                                                                 */
  /* ---------------------------------------------------------------------- */

  function $(selector, scope) {
    return (scope || root).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || root).querySelectorAll(selector));
  }

  /* Prices always go through the shop's money_format — never a hardcoded $. */
  function money(cents) {
    if (typeof FF.money === 'function') return FF.money(cents);
    return '$' + ((Number(cents) || 0) / 100).toFixed(2);
  }

  function parseJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error('[FF] malformed product JSON:', error);
      return null;
    }
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  var variants = parseJSON($('[data-ff-variants]')) || [];
  if (!variants.length) return;

  /* 1-based option positions, matching Liquid's option1/2/3. 0 = not present. */
  var colorPosition = parseInt(root.dataset.colorPosition, 10) || 0;
  var optionCount = parseInt(root.dataset.optionCount, 10) || 1;

  /* ---------------------------------------------------------------------- */
  /* Selection state                                                         */
  /* ---------------------------------------------------------------------- */

  /* selected[i] is the chosen value for option position i+1. */
  var selected = [];
  for (var i = 0; i < optionCount; i++) {
    var checked = $('input[name="ff-option-' + (i + 1) + '"]:checked');
    selected[i] = checked ? checked.value : null;
  }

  function findVariant(values) {
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      var match = true;
      for (var o = 0; o < values.length; o++) {
        if (values[o] !== null && variant.options[o] !== values[o]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  }

  /* A value is offered when some in-stock variant exists with the rest of the
     current selection held fixed. Used to gray out sold-out sizes/colors. */
  function valueAvailable(position, value) {
    var probe = selected.slice();
    probe[position - 1] = value;
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (!variant.available) continue;
      var match = true;
      for (var o = 0; o < probe.length; o++) {
        if (probe[o] !== null && variant.options[o] !== probe[o]) {
          match = false;
          break;
        }
      }
      if (match) return true;
    }
    return false;
  }

  function currentVariant() {
    return findVariant(selected);
  }

  /* ---------------------------------------------------------------------- */
  /* Add-ons and gift                                                        */
  /* ---------------------------------------------------------------------- */

  var addonInputs = $$('input[name="ff-addon"]');

  function selectedAddon() {
    for (var a = 0; a < addonInputs.length; a++) {
      if (addonInputs[a].checked) return addonInputs[a];
    }
    return null;
  }

  /* Add-ons and the gift are separate products, so they are matched by their
     variant title containing the selected color — the same convention the
     merchant already uses when naming variants. */
  function matchByColor(list, color) {
    if (!list || !list.length) return null;
    var pool = list.filter(function (entry) {
      return entry.available !== false;
    });
    if (!pool.length) return null;
    if (color) {
      var hit = pool.filter(function (entry) {
        return String(entry.title || '').indexOf(color) !== -1;
      })[0];
      if (hit) return hit;
    }
    return pool[0];
  }

  function currentColor() {
    return colorPosition ? selected[colorPosition - 1] : null;
  }

  function addonVariant(input) {
    var data = parseJSON(document.getElementById(input.dataset.variantsId));
    return matchByColor(data, currentColor());
  }

  function giftVariant() {
    var giftEl = $('[data-ff-gift-variants]');
    if (!giftEl) return null;
    return matchByColor(parseJSON(giftEl), currentColor());
  }

  /* ---------------------------------------------------------------------- */
  /* Gallery                                                                 */
  /* ---------------------------------------------------------------------- */

  var track = $('[data-ff-gallery-track]');
  var slides = track ? $$('.ff-pdp__slide', track) : [];
  var thumbs = $$('[data-ff-gallery-jump]');
  var counter = $('[data-ff-gallery-counter]');
  var bar = $('[data-ff-gallery-bar]');
  var prevBtn = $('[data-ff-gallery-prev]');
  var nextBtn = $('[data-ff-gallery-next]');
  var scroller = $('[data-ff-gallery-scroller]');
  var railThumb = $('[data-ff-gallery-rail-thumb]');

  function visibleSlides() {
    return slides.filter(function (slide) {
      return !slide.hidden;
    });
  }

  function activeIndex() {
    if (!track || !track.clientWidth) return 0;
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function goTo(index, smooth) {
    if (!track) return;
    var total = visibleSlides().length;
    var clamped = Math.max(0, Math.min(index, total - 1));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior:
        smooth === false || (FF.prefersReducedMotion && FF.prefersReducedMotion())
          ? 'auto'
          : 'smooth'
    });
  }

  function paintGallery() {
    if (!track) return;
    var shown = visibleSlides();
    var index = Math.min(activeIndex(), Math.max(shown.length - 1, 0));

    if (counter) counter.textContent = shown.length ? index + 1 + ' / ' + shown.length : '';
    if (bar && shown.length) {
      bar.style.width = 100 / shown.length + '%';
      bar.style.transform = 'translateX(' + index * 100 + '%)';
    }
    if (prevBtn) prevBtn.disabled = index <= 0;
    if (nextBtn) nextBtn.disabled = index >= shown.length - 1;

    var activeSlide = shown[index];
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle(
        'is-active',
        !!activeSlide && thumb.dataset.ffGalleryJump === activeSlide.dataset.ffIdx
      );
    });
  }

  /* Hide the media that belongs to a different color. Media with no color tag
     (detail shots, flat lays) always stays. If a color has no media of its
     own, nothing is hidden — better a full gallery than an empty one. */
  function filterGallery(color) {
    if (!track) return;
    var key = handleize(color);
    var hasOwn =
      !!key &&
      slides.some(function (slide) {
        return slide.dataset.ffColor === key;
      });

    slides.forEach(function (slide) {
      var tag = slide.dataset.ffColor;
      slide.hidden = hasOwn && tag && tag !== key;
    });

    thumbs.forEach(function (thumb) {
      var tag = thumb.dataset.ffColor;
      thumb.hidden = hasOwn && tag && tag !== key;
    });

    track.scrollTo({ left: 0, behavior: 'auto' });
    paintGallery();
  }

  if (track) {
    track.addEventListener('scroll', FF.raf ? FF.raf(paintGallery) : paintGallery, { passive: true });

    /* Left/right arrows page the track when it has focus. */
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(activeIndex() + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(activeIndex() - 1);
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex() + 1);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = visibleSlides().indexOf(
          slides.filter(function (slide) {
            return slide.dataset.ffIdx === thumb.dataset.ffGalleryJump;
          })[0]
        );
        if (target >= 0) goTo(target);
      });
    });

    window.addEventListener('resize', FF.debounce ? FF.debounce(paintGallery, 150) : paintGallery);
  }

  /* The vertical rail mirrors the gallery column's own scroll position. */
  if (scroller && railThumb) {
    var paintRail = function () {
      var ratio = scroller.clientHeight / scroller.scrollHeight;
      if (ratio >= 1) {
        railThumb.style.display = 'none';
        return;
      }
      railThumb.style.display = '';
      railThumb.style.height = ratio * 100 + '%';
      var travel = (scroller.scrollTop / scroller.scrollHeight) * scroller.clientHeight;
      railThumb.style.transform = 'translateY(' + travel + 'px)';
    };
    scroller.addEventListener('scroll', FF.raf ? FF.raf(paintRail) : paintRail, { passive: true });
    window.addEventListener('resize', FF.debounce ? FF.debounce(paintRail, 150) : paintRail);
    paintRail();
  }

  /* ---------------------------------------------------------------------- */
  /* Render                                                                  */
  /* ---------------------------------------------------------------------- */

  var form = $('[data-ff-form]');
  var variantInput = $('[data-ff-variant-input]');
  var atc = $('[data-ff-atc]');
  var atcLabel = $('[data-ff-atc-label]');
  var lastColor = null;

  function renderOptions() {
    for (var position = 1; position <= optionCount; position++) {
      $$('input[name="ff-option-' + position + '"]').forEach(function (input) {
        var wrapper = input.closest('.ff-pdp__swatch, .ff-pdp__size');
        if (!wrapper) return;
        wrapper.classList.toggle('is-active', input.checked);

        /* Sold-out values stay selectable — blocking them would strand a
           shopper who picked an unavailable size first. They are marked
           instead, visually and for screen readers. */
        var offered = valueAvailable(Number(input.dataset.position), input.value);
        wrapper.classList.toggle('is-unavailable', !offered);
        var flag = wrapper.querySelector('[data-ff-soldout]');
        if (flag) flag.hidden = offered;
      });
    }

    var color = currentColor();
    var nameEl = $('[data-ff-color-name]');
    if (nameEl) nameEl.textContent = color || '';

    var noteEl = $('[data-ff-color-note]');
    if (noteEl) {
      var activeColor = $('input[name="ff-option-' + colorPosition + '"]:checked');
      noteEl.textContent = (activeColor && activeColor.dataset.note) || '';
    }

    if (color !== lastColor) {
      lastColor = color;
      filterGallery(color);
    }
  }

  function renderPrice(variant) {
    var addon = selectedAddon();
    var addonV = addon ? addonVariant(addon) : null;
    var total = (variant ? variant.price : 0) + (addonV ? addonV.price : 0);

    var priceEl = $('[data-ff-price]');
    if (priceEl) priceEl.textContent = money(total);

    var wasEl = $('[data-ff-was]');
    var chip = $('[data-ff-save-chip]');
    var compare = variant && variant.compare_at_price ? variant.compare_at_price : 0;
    var showSale = !!variant && !addonV && compare > variant.price;

    if (wasEl) {
      wasEl.textContent = showSale ? money(compare) : '';
      wasEl.hidden = !showSale;
    }
    if (chip) {
      var saveTemplate = chip.dataset.template || 'Save [amount]';
      chip.textContent = showSale
        ? saveTemplate.replace('[amount]', money(compare - variant.price))
        : '';
      chip.hidden = !showSale;
    }

    var afterpay = $('[data-ff-afterpay]');
    if (afterpay) {
      var template = afterpay.dataset.template || '';
      afterpay.textContent =
        template && total ? template.replace('[amount]', money(Math.round(total / 4))) : '';
    }

    return total;
  }

  function renderAddons() {
    addonInputs.forEach(function (input) {
      var wrapper = input.closest('.ff-pdp__addon');
      if (!wrapper) return;
      wrapper.classList.toggle('is-active', input.checked);

      var match = addonVariant(input);
      wrapper.classList.toggle('is-unavailable', !match);
      input.disabled = !match;

      var priceEl = $('[data-ff-addon-price]', wrapper);
      if (priceEl) priceEl.textContent = match ? '+' + money(match.price) : '—';

      var metaEl = $('[data-ff-addon-meta]', wrapper);
      if (metaEl) metaEl.textContent = match ? match.title : '';

      var saveEl = $('[data-ff-addon-save]', wrapper);
      if (saveEl) {
        var compare = match && match.compare_at_price ? match.compare_at_price : 0;
        var show = !!match && compare > match.price;
        saveEl.textContent = show
          ? (saveEl.dataset.template || 'Save [amount]').replace(
              '[amount]',
              money(compare - match.price)
            )
          : '';
        saveEl.hidden = !show;
      }
    });

    var clear = $('[data-ff-addon-clear]');
    if (clear) clear.hidden = !selectedAddon();
  }

  function renderStock(variant) {
    var stock = $('[data-ff-stock]');
    if (!stock) return;

    var label = $('[data-ff-stock-label]', stock);
    var note = $('[data-ff-stock-note]', stock);
    var state = 'in';
    if (!variant || !variant.available) state = 'out';
    else if (variant.low) state = 'low';

    stock.classList.toggle('ff-pdp__stock--low', state === 'low');
    stock.classList.toggle('ff-pdp__stock--out', state === 'out');

    if (label) label.textContent = stock.dataset[state + 'Label'] || '';
    if (note) note.textContent = state === 'out' ? '' : stock.dataset.note || '';
  }

  function syncUrl(variant) {
    if (!variant || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      /* Non-fatal: a browser that dislikes the URL still has a working page. */
    }
  }

  function render() {
    var variant = currentVariant();

    renderOptions();
    renderAddons();
    var total = renderPrice(variant);
    renderStock(variant);
    renderSticky(variant, total);

    if (variantInput) variantInput.value = variant ? variant.id : '';

    if (atc) atc.disabled = !variant || !variant.available;
    if (atcLabel) {
      if (!variant) atcLabel.textContent = atcLabel.dataset.unavailable || 'Unavailable';
      else if (!variant.available) atcLabel.textContent = atcLabel.dataset.soldOut || 'Sold out';
      else {
        var template = atcLabel.dataset.template || '[label]';
        atcLabel.textContent = template
          .replace('[label]', atcLabel.dataset.label || 'Add to cart')
          .replace('[amount]', money(total));
      }
    }

    syncUrl(variant);
  }

  /* ---------------------------------------------------------------------- */
  /* Wiring                                                                  */
  /* ---------------------------------------------------------------------- */

  $$('input[data-ff-option]').forEach(function (input) {
    input.addEventListener('change', function () {
      selected[Number(input.dataset.position) - 1] = input.value;
      render();
    });
  });

  addonInputs.forEach(function (input) {
    input.addEventListener('change', render);
  });

  var clearBtn = $('[data-ff-addon-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      addonInputs.forEach(function (input) {
        input.checked = false;
      });
      render();
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Add to cart                                                             */
  /* ---------------------------------------------------------------------- */

  var busy = false;
  var noticeTimer = null;

  function announce(variant, addonV) {
    var notice = $('[data-ff-added]');
    if (!notice) return;
    var bits = selected.filter(Boolean).join(' · ');
    notice.textContent = (addonV ? bits + ' + ' + addonV.title : bits) + ' ' +
      (notice.dataset.suffix || 'added to your cart');
    notice.hidden = false;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      notice.hidden = true;
    }, 2600);
  }

  function showError(message) {
    var el = $('[data-ff-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      var variant = currentVariant();
      if (!variant || !variant.available || busy) {
        event.preventDefault();
        return;
      }
      if (!window.fetch) return; /* no fetch: let the browser POST the form */

      event.preventDefault();
      busy = true;
      if (atc) atc.setAttribute('aria-busy', 'true');

      var errorEl = $('[data-ff-error]');
      if (errorEl) errorEl.hidden = true;

      var items = [{ id: variant.id, quantity: 1 }];

      var addon = selectedAddon();
      var addonV = addon ? addonVariant(addon) : null;
      if (addonV) items.push({ id: addonV.id, quantity: 1 });

      var gift = giftVariant();
      if (gift) items.push({ id: gift.id, quantity: 1, properties: { _ff_gift: '1' } });

      var routes = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(routes + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          /* A bundled gift or add-on can be out of stock between render and
             click. Retry with the main item alone rather than failing the
             whole add. */
          if (!result.ok && items.length > 1) {
            return fetch(routes + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [items[0]] })
            }).then(function (response) {
              return response.json().then(function (data) {
                return { ok: response.ok, data: data };
              });
            });
          }
          return result;
        })
        .then(function (result) {
          if (!result.ok) throw new Error((result.data && result.data.description) || 'cart');
          announce(variant, addonV);
          if (typeof FF.emit === 'function') FF.emit('cart:added', result.data);
          else document.dispatchEvent(new CustomEvent('ff:cart:added', { detail: result.data }));
        })
        .catch(function (error) {
          console.error('[FF] add to cart failed:', error);
          /* Last resort: hand the request back to the browser so the shopper
             still ends up with the item in their cart. */
          showError(form.dataset.errorMessage || 'Something went wrong. Taking you to your cart…');
          form.submit();
        })
        .then(function () {
          busy = false;
          if (atc) atc.removeAttribute('aria-busy');
        });
    });
  }


  /* ---------------------------------------------------------------------- */
  /* Lightbox                                                                */
  /*                                                                         */
  /* Shares the gallery's own media list: it pages through visibleSlides(),  */
  /* the same array the color filter narrows, so choosing a color and then */
  /* opening the viewer can never show an image the gallery has hidden.      */
  /* ---------------------------------------------------------------------- */

  var lightbox = $('[data-ff-lightbox]');
  var lbPanel = lightbox && $('.ff-lightbox__panel', lightbox);
  var lbImg = lightbox && $('[data-ff-lb-img]', lightbox);
  var lbPrev = lightbox && $('[data-ff-lb-prev]', lightbox);
  var lbNext = lightbox && $('[data-ff-lb-next]', lightbox);
  var lbCount = lightbox && $('[data-ff-lb-count]', lightbox);
  var lbIndex = 0;
  var lbRelease = null;

  function lbOpen() {
    return !!lightbox && !lightbox.hidden;
  }

  function lbShow(index) {
    if (!lightbox || !lbImg) return;

    var shown = visibleSlides();
    if (!shown.length) return;

    lbIndex = Math.max(0, Math.min(index, shown.length - 1));
    var slide = shown[lbIndex];

    /* data-ff-full is a wider render of the same media, written by the
       section. Fall back to the inline <img> if it is missing. */
    var inline = slide.querySelector('img');
    lbImg.src = slide.dataset.ffFull || (inline && inline.currentSrc) || (inline && inline.src) || '';
    lbImg.alt = slide.dataset.ffAlt || '';
    if (slide.dataset.ffW) lbImg.setAttribute('width', slide.dataset.ffW);
    if (slide.dataset.ffH) lbImg.setAttribute('height', slide.dataset.ffH);

    if (lbCount) lbCount.textContent = lbIndex + 1 + ' / ' + shown.length;
    if (lbPrev) lbPrev.disabled = lbIndex <= 0;
    if (lbNext) lbNext.disabled = lbIndex >= shown.length - 1;
  }

  function openLightbox(index) {
    if (!lightbox || lbOpen()) return;
    if (!visibleSlides().length) return;

    lbShow(index);
    lightbox.hidden = false;

    if (typeof FF.lockScroll === 'function') FF.lockScroll(true);
    /* trapFocus captures the element that had focus, so release() hands it
       back — no separate "opener" bookkeeping needed. */
    lbRelease = typeof FF.trapFocus === 'function' ? FF.trapFocus(lbPanel) : null;

    var close = lightbox.querySelector('[data-ff-lb-close]');
    if (close && close.focus) close.focus();
  }

  function closeLightbox() {
    if (!lbOpen()) return;

    lightbox.hidden = true;
    if (typeof FF.lockScroll === 'function') FF.lockScroll(false);
    if (lbRelease) {
      lbRelease();
      lbRelease = null;
    }
    /* Leave the gallery on whatever the shopper was last looking at. */
    goTo(lbIndex, false);
  }

  if (lightbox) {
    $$('[data-ff-lb-close]', lightbox).forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    if (lbPrev) {
      lbPrev.addEventListener('click', function () {
        lbShow(lbIndex - 1);
      });
    }
    if (lbNext) {
      lbNext.addEventListener('click', function () {
        lbShow(lbIndex + 1);
      });
    }

    var lbOpener = $('[data-ff-lb-open]');
    if (lbOpener) {
      lbOpener.addEventListener('click', function () {
        openLightbox(activeIndex());
      });
    }

    /* The stage image itself opens the viewer, which is what a shopper
       reaches for first. The arrows sit above it and stop the event. */
    if (track) {
      track.addEventListener('click', function (event) {
        if (!event.target || !event.target.closest) return;
        if (event.target.closest('.ff-pdp__garrow, .ff-pdp__zoom')) return;
        var slide = event.target.closest('.ff-pdp__slide');
        if (!slide || slide.hidden) return;
        var pos = visibleSlides().indexOf(slide);
        if (pos >= 0) openLightbox(pos);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!lbOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        lbShow(lbIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        lbShow(lbIndex + 1);
      }
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Size guide drawer                                                       */
  /* ---------------------------------------------------------------------- */

  var guide = $('[data-ff-guide]');
  var guideScrim = $('[data-ff-guide-scrim]');
  var guideOpener = $('[data-ff-open-guide]');
  var guideRelease = null;
  var guideTimer = null;

  function guideIsOpen() {
    return !!guide && !guide.hidden;
  }

  function openGuide() {
    if (!guide || guideIsOpen()) return;

    clearTimeout(guideTimer);
    guide.hidden = false;
    if (guideScrim) guideScrim.hidden = false;

    /* Force a layout read between "displayed" and "open" so the transform
       actually has two states to animate between. */
    void guide.offsetWidth;

    guide.classList.add('is-open');
    if (guideScrim) guideScrim.classList.add('is-open');
    if (guideOpener) guideOpener.setAttribute('aria-expanded', 'true');

    if (typeof FF.lockScroll === 'function') FF.lockScroll(true);
    guideRelease = typeof FF.trapFocus === 'function' ? FF.trapFocus(guide) : null;

    var close = guide.querySelector('[data-ff-close-guide]');
    if (close && close.focus) close.focus();
  }

  function closeGuide() {
    if (!guideIsOpen()) return;

    guide.classList.remove('is-open');
    if (guideScrim) guideScrim.classList.remove('is-open');
    if (guideOpener) guideOpener.setAttribute('aria-expanded', 'false');

    if (typeof FF.lockScroll === 'function') FF.lockScroll(false);
    if (guideRelease) {
      guideRelease();
      guideRelease = null;
    }

    /* Take it out of the tree once the slide-out has run. A timer rather
       than transitionend: transitionend never fires under reduced motion
       (there is no transition), and it also bubbles from children. 420ms
       clears the 360ms transform in the stylesheet. */
    clearTimeout(guideTimer);
    guideTimer = setTimeout(function () {
      /* Reopened in the meantime — leave it alone. */
      if (guide.classList.contains('is-open')) return;
      guide.hidden = true;
      if (guideScrim) guideScrim.hidden = true;
    }, 420);
  }

  if (guide) {
    if (guideOpener) guideOpener.addEventListener('click', openGuide);

    $$('[data-ff-close-guide]', guide).forEach(function (el) {
      el.addEventListener('click', closeGuide);
    });

    if (guideScrim) guideScrim.addEventListener('click', closeGuide);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !guideIsOpen()) return;
      event.preventDefault();
      closeGuide();
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Sticky buy bar                                                          */
  /*                                                                         */
  /* Driven by two IntersectionObservers rather than a scroll handler: one    */
  /* on the buy box (has it gone past?) and one on the footer (are we about   */
  /* to cover it?). No IntersectionObserver means no bar, which is fine —     */
  /* the real buy box is still up the page.                                   */
  /* ---------------------------------------------------------------------- */

  var sticky = $('[data-ff-sticky]');
  var stickyVariant = sticky && $('[data-ff-sticky-variant]', sticky);
  var stickyPrice = sticky && $('[data-ff-sticky-price]', sticky);
  var stickyAtc = sticky && $('[data-ff-atc-mirror]', sticky);

  function renderSticky(variant, total) {
    if (!sticky) return;

    if (stickyVariant) stickyVariant.textContent = selected.filter(Boolean).join(' · ');
    if (stickyPrice) stickyPrice.textContent = money(total);

    if (stickyAtc) {
      var available = !!variant && variant.available;
      stickyAtc.disabled = !available;
      stickyAtc.textContent = available
        ? (atcLabel && atcLabel.dataset.label) || 'Add to cart'
        : (atcLabel && atcLabel.dataset.soldOut) || 'Sold out';
    }
  }

  if (sticky && 'IntersectionObserver' in window) {
    var buybox = $('.ff-pdp__buybox');
    var footer = document.querySelector('.ff-footer');
    var pastBuybox = false;
    var nearFooter = false;

    var paintSticky = function () {
      sticky.classList.toggle('is-visible', pastBuybox && !nearFooter);
    };

    if (buybox) {
      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var bounds = entry.rootBounds;
          /* Scrolled past, not merely off screen: the buy box has to have
             left through the TOP of the viewport. */
          pastBuybox = bounds
            ? !entry.isIntersecting && entry.boundingClientRect.bottom <= bounds.top
            : !entry.isIntersecting && entry.boundingClientRect.bottom < 80;
          paintSticky();
        },
        /* Matches the reference's 80px hand-off under the sticky header. */
        { rootMargin: '-80px 0px 0px 0px', threshold: 0 }
      ).observe(buybox);
    }

    if (footer) {
      new IntersectionObserver(
        function (entries) {
          nearFooter = entries[0].isIntersecting;
          paintSticky();
        },
        { rootMargin: '0px 0px -60px 0px', threshold: 0 }
      ).observe(footer);
    }
  }

  render();
  paintGallery();
})();
